<template>
    <v-app >

      <v-dialog
        v-model="ula_dialog"
        persistent
        scrollable
      >
          <v-card>
              <v-card-title>{{ $t('ula_acception_title') }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text align="left" class="text-body-2 mt-4">
                  <span style="white-space: pre-line;">
                  {{station_annooucement_ula}}
                  </span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="reject_ula"
                >
                  {{ $t('ula_not_accept') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="accpt_ula"
                >
                  {{ $t('ula_accept') }}
                </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>

        <div class="ma-4" align="left">
            <div class="text-h6 mb-12">
                <v-icon>mdi-pencil-box-outline</v-icon> {{ $t('registerform_title') }}
            </div>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
            <div v-for="item in registerformlist" :key="item.form_tag" align="left">
                <div class="subtitle-2" v-if="item.is_required!=2">
                    <b>{{ $t('form_tag_' + item.form_tag) }}</b>
                    <small v-if="item.is_required==1"> (*{{ $t('form_is_required_yes_short') }})</small>
                </div>
                <div v-if="item.value_type_id==1 && item.is_required!=2">
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                :label="$t('firstname')"
                                outlined
                                dense
                                :value="vmodel_values['form_id_' + item.form_id + '_0']" 
                                @input="value => vmodel_values['form_id_' + item.form_id + '_0'] = value"
                                :rules="item.is_required==1 ? rule_requied : []"
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col v-show="false">
                                    <v-text-field
                                        :label="$t('middlename')"
                                        outlined
                                        dense
                                        :value="vmodel_values['form_id_' + item.form_id + '_1']" 
                                        @input="value => vmodel_values['form_id_' + item.form_id + '_1'] = value"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                        <v-col cols="6">
                            <v-text-field
                                :label="$t('lastname')"
                                outlined
                                dense
                                :value="vmodel_values['form_id_' + item.form_id + '_2']" 
                                @input="value => vmodel_values['form_id_' + item.form_id + '_2'] = value"
                                :rules="item.is_required==1 ? rule_requied : []"
                                hide-details
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <div v-else-if="item.value_type_id==2 && item.is_required!=2">
                    <v-row>
                        <v-col cols="6">
                            <v-select
                                :items="[{name:$t('citizenid'),val:'1'}
                                //,{name:$t('passport'),val:'2'}
                                ]"
                                item-text="name"
                                item-value="val"
                                outlined
                                dense
                                :value="vmodel_values['form_id_' + item.form_id + '_0']" 
                                @input="value => {vmodel_values['form_id_' + item.form_id + '_0'] = value;current_citizen=value;}"
                                :rules="item.is_required==1 ? rule_requied : []"
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                outlined
                                dense
                                :value="vmodel_values['form_id_' + item.form_id + '_1']" 
                                @input="value => vmodel_values['form_id_' + item.form_id + '_1'] = value"
                                :rules="(current_citizen == '1' ? rule_idcard : []).concat(item.is_required==1 ? rule_requied : [])"
                                hide-details
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <div v-else-if="item.value_type_id==6 && item.is_required!=2">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                :items="[
                                    {name:'รถแทรกเตอร์',val:'รถแทรกเตอร์'}
                                    ,{name:'รถเกี่ยวนวดข้าว',val:'รถเกี่ยวนวดข้าว'}
                                    ,{name:'รถขุด',val:'รถขุด'}
                                    ,{name:'รถดำนา',val:'รถดำนา'}
                                ]"
                                item-text="name"
                                item-value="val"
                                outlined
                                dense
                                :value="vmodel_values['form_id_' + item.form_id]" 
                                @input="value => vmodel_values['form_id_' + item.form_id] = value"
                                :rules="item.is_required==1 ? rule_requied : []"
                                hide-details
                            ></v-select>
                        </v-col>
                    </v-row>
                </div>
                <div v-else-if="item.value_type_id==7 && item.is_required!=2">
                    <v-row>
                        <v-col cols="3">
                            <v-select
                                :items="[
                                    '01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'
                                ]"
                                outlined
                                dense
                                label="วัน"
                                :value="vmodel_values['form_id_' + item.form_id + '_0']" 
                                @input="value => vmodel_values['form_id_' + item.form_id + '_0'] = value"
                                :rules="item.is_required==1 ? rule_requied : []"
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-select
                                :items="[
                                    {name:'มกราคม',val:'01'}
                                    ,{name:'กุมภาพันธ์',val:'02'}
                                    ,{name:'มีนาคม',val:'03'}
                                    ,{name:'เมษายน',val:'04'}
                                    ,{name:'พฤษภาคม',val:'05'}
                                    ,{name:'มิถุนายน',val:'06'}
                                    ,{name:'กรกฎาคม',val:'07'}
                                    ,{name:'สิงหาคม',val:'08'}
                                    ,{name:'กันยายน',val:'09'}
                                    ,{name:'ตุลาคม',val:'10'}
                                    ,{name:'พฤศจิกายน',val:'11'}
                                    ,{name:'ธันวาคม',val:'12'}
                                ]"
                                item-text="name"
                                item-value="val"
                                label="เดือน"
                                outlined
                                dense
                                :value="vmodel_values['form_id_' + item.form_id + '_1']" 
                                @input="value => vmodel_values['form_id_' + item.form_id + '_1'] = value"
                                :rules="item.is_required==1 ? rule_requied : []"
                                hide-details
                            ></v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field
                                outlined
                                dense
                                label="พ.ศ."
                                :value="vmodel_values['form_id_' + item.form_id + '_2']" 
                                @input="value => vmodel_values['form_id_' + item.form_id + '_2'] = value"
                                :rules="(item.is_required==1 ? rule_requied : []).concat(rule_year)"
                                hide-details
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <div v-else-if="item.is_required!=2">
                    <v-col cols="12" class="ml-n3">
                        <v-text-field
                            outlined
                            dense
                            :value="vmodel_values['form_id_' + item.form_id]" 
                            @input="value => vmodel_values['form_id_' + item.form_id] = value"
                            :rules="item.is_required==1 ? rule_requied : []"
                            hide-details
                        ></v-text-field>
                    </v-col>
                </div>
            </div>
            </v-form>
            <div align="center">
                <v-btn  color="#00E4FF" class="pa-5 text-h5 ma-2" width="80%" @click="confirm" :disabled="!valid">
                    {{ $t('registerform_submit') }}
                </v-btn>
            </div>
        </div>
    </v-app>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'
import App from '@/models/instance/App'
import AppointmentSelection from '@/models/instance/AppointmentSelection'
import Formrule from '@/models/Formrule';

export default {
  props: ['nextstep'],
  data () {
    return {
      current_citizen:'1',
      vmodel_values: {},
      valid: true,
      registerformlist : [],
      ula_dialog:false,
      station_annooucement_ula : ""
      ,...Formrule
    }
  },
  mounted : function () {
    this.$store.getters.getStationShortDetail(this.$route.params.station_code)
    .then(station_shortdetail=>{
        this.station_annooucement_ula = station_shortdetail.station_annooucement_ula
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.line.station.get_stationmemberstatus
          ,{ station_code:this.$route.params.station_code}
          ,{ headers: Member.getTokenHeader()})
        .then(response => {
            if(response.data.is_stationmember){
                this.$store.commit('finishLoading',que)
                if(config['register_callback']!=undefined && config['register_callback'][App.getAppId()]!=undefined){
                    this.$route.params.callback = config['register_callback'][App.getAppId()]
                }
                if(this.$route.params.callback==undefined  || this.$route.params.callback.name=="Success"){
                    this.$route.params.callback = {
                        name:"Success",params: { 
                        success_text_1:  this.$t('success_alreadymember_1')
                        ,success_text_2:  this.$t('success_alreadymember_2')
                        }
                    }
                }
                if(this.$route.params.callback.includes("http")){
                    window.location.href = this.$route.params.callback
                }else{
                    this.$router.replace(this.$route.params.callback)
                } 
            }else{   
                axios
                .post(config.api.url.public.station.get_registerform,{station_code:this.$route.params.station_code})
                .then(response => {
                    this.registerformlist = response.data.registerformlist
                    response.data.registerformlist.forEach(f=>{
                        if(f.value_type_id == 1){
                            this.vmodel_values['form_id_' + f.form_id + '_0'] = ""
                            this.vmodel_values['form_id_' + f.form_id + '_1'] = ""
                            this.vmodel_values['form_id_' + f.form_id + '_2'] = ""
                        }else if(f.value_type_id == 2){
                            this.current_citizen = '1'
                            this.vmodel_values['form_id_' + f.form_id + '_0'] = '1'
                            this.vmodel_values['form_id_' + f.form_id + '_1'] = ""
                        }else if(f.value_type_id == 7){
                            this.vmodel_values['form_id_' + f.form_id + '_0'] = ""
                            this.vmodel_values['form_id_' + f.form_id + '_1'] = ""
                            this.vmodel_values['form_id_' + f.form_id + '_2'] = ""
                        }else{
                            this.vmodel_values['form_id_' + f.form_id] = ""
                        }
                    })
                    axios
                    .post(config.api.url.line.station.get_stationmemberform
                        ,{ station_code:this.$route.params.station_code}
                        ,{ headers: Member.getTokenHeader()})
                    .then(response1 => {
                        response1.data.forEach(f => {
                            if(f.form_value != null){
                                var ff = this.registerformlist.filter(r=>r.form_id == f.form_id)[0]
                                if(ff.value_type_id == 1){
                                    this.vmodel_values['form_id_' + f.form_id + '_0'] = f.form_value.split(',')[0]
                                    this.vmodel_values['form_id_' + f.form_id + '_1'] = f.form_value.split(',')[1]
                                    this.vmodel_values['form_id_' + f.form_id + '_2'] = f.form_value.split(',')[2]
                                }else if(ff.value_type_id == 2){
                                    this.current_citizen = f.form_value.split(',')[0]
                                    this.vmodel_values['form_id_' + f.form_id + '_0'] = f.form_value.split(',')[0]
                                    this.vmodel_values['form_id_' + f.form_id + '_1'] = f.form_value.split(',')[1]
                                }else if(ff.value_type_id == 7){
                                    this.vmodel_values['form_id_' + f.form_id + '_0'] = f.form_value.substring(0,2)
                                    this.vmodel_values['form_id_' + f.form_id + '_1'] = f.form_value.substring(2,4)
                                    this.vmodel_values['form_id_' + f.form_id + '_2'] = (parseInt(f.form_value.substring(4,8)) + 543).toString()
                                }else{
                                    this.vmodel_values['form_id_' + f.form_id] = f.form_value
                                }
                            }
                        });
                        this.valid = this.$refs.form.validate()
                        axios
                        .post(config.api.url.line.station.get_stationmemberula
                            ,{ station_code:this.$route.params.station_code}
                            ,{ headers: Member.getTokenHeader()})
                        .then(response => {
                            this.$store.commit('finishLoading',que)
                            if(response.data){
                                this.ula_dialog = false
                            }else{
                                this.ula_dialog = true
                            }
                        })
                    })
                })
            }
        })
    });
  },
  methods : {
      confirm(){
        console.log(this.vmodel_values)
        this.valid = this.$refs.form.validate()
        if(this.valid==true){
            var form_values = {}
            this.registerformlist.forEach(f=>{
                if(f.value_type_id==1){
                    if(this.vmodel_values['form_id_' + f.form_id + '_0'].length > 0 || this.vmodel_values['form_id_' + f.form_id + '_2'].length > 0){
                        form_values[f.form_id] = [
                            this.vmodel_values['form_id_' + f.form_id + '_0']
                            ,this.vmodel_values['form_id_' + f.form_id + '_1']
                            ,this.vmodel_values['form_id_' + f.form_id + '_2']
                        ].join(',')
                    }
                }else if(f.value_type_id==2){
                    if(this.vmodel_values['form_id_' + f.form_id + '_1'].length > 0){
                        form_values[f.form_id] = [
                            this.vmodel_values['form_id_' + f.form_id + '_0']
                            ,this.vmodel_values['form_id_' + f.form_id + '_1']
                        ].join(',')
                    }
                }else if(f.value_type_id==7){
                    if(this.vmodel_values['form_id_' + f.form_id + '_0'].length > 0 && this.vmodel_values['form_id_' + f.form_id + '_1'].length > 0 && this.vmodel_values['form_id_' + f.form_id + '_2'].length == 4){
                        form_values[f.form_id] = [
                            this.vmodel_values['form_id_' + f.form_id + '_0']
                            ,this.vmodel_values['form_id_' + f.form_id + '_1']
                            ,parseInt(this.vmodel_values['form_id_' + f.form_id + '_2']) - 543
                        ].join('')
                    }
                }else{
                    if(this.vmodel_values['form_id_' + f.form_id].length > 0){
                        form_values[f.form_id] = this.vmodel_values['form_id_' + f.form_id]
                    }
                }
            })
            if(Object.keys(form_values).length>0){
                form_values['x'] = 'x';
            }
            console.log(form_values)
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.line.station.register
            ,{ 
                app_id:App.getAppId()
                ,station_code:this.$route.params.station_code
                ,formvalue:form_values
            }
            ,{ headers: Member.getTokenHeader()})
            .then(response => {
                this.$store.commit('finishLoading',que)
                if(config['register_callback']!=undefined && config['register_callback'][App.getAppId()]!=undefined){
                    this.$route.params.callback = config['register_callback'][App.getAppId()]
                }
                if(this.$route.params.callback==undefined){
                    this.$route.params.callback = {
                        name:"Success",params: { 
                        success_text_1:  response.data.staff_register_mode == 'auto_accept' ? this.$t('success_register_auto_accept_1') : this.$t('success_register_1')
                        ,success_text_2: response.data.staff_register_mode == 'auto_accept' ? this.$t('success_register_auto_accept_2') : this.$t('success_register_2')
                        }
                    }
                }
                if((typeof this.$route.params.callback === 'string' || this.$route.params.callback instanceof String) && this.$route.params.callback.includes("http")){
                    window.location.href = this.$route.params.callback
                }else{
                    this.$router.replace(this.$route.params.callback)
                } 
            })
        }
      },
    accpt_ula  : function() {
      this.ula_dialog = false
      var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.line.station.accept_ula
        ,{ 
            app_id:App.getAppId()
            ,station_code:this.$route.params.station_code
            ,ula:this.station_annooucement_ula
        }
        ,{ headers: Member.getTokenHeader()})
        .then(() => {
            this.$store.commit('finishLoading',que)
        })
    },
    reject_ula  : function() {
        if(window.history.length>0){
            this.$router.go(-1)
        }else{
            window.location.href = AppointmentSelection.getAddfriendUrl()
        }
    }
  },
}
</script>